import React from 'react';

import PropTypes from 'prop-types';

import { useDispatch } from 'react-redux';
import { t } from 'i18next';

import { Button, Col, Divider, Modal, Row } from 'antd';
import { exportSelectedPortfolio } from '../../../data/store/portfolio/portfolioActions';

const ModalExportPortfolio = ({open, close, portfolios} ) => {
  const dispatch = useDispatch();

  const getPortfolioName = (id) => {
    const portfolio = portfolios?.find((i) => i.id === +id);
    return {key: portfolio?.id, name: portfolio?.name, code: portfolio?.portfolio_code};
  };

  const onExport = () => {
    dispatch(exportSelectedPortfolio({
      close, 
      portfolio_ids: open,
      format: { key: 'xlsx' }}));
  };

  return (
    <Modal
      width={700}
      className="modal-content-paper"
      open={open}
      onCancel={close}
      footer={null}
      zIndex={1600}
      destroyOnClose
    >
      <Row justify="start">
        <Col className="modal-title">{t('EXPORT_PORTFOLIO')}</Col>
      </Row>
      <Divider className="modal-divider" />
      <Row justify="start" className="modal-text-wrapper">
        <Col>
          <p className="modal-description">{t('EXPORT_PORTFOLIO_PROMT')}</p>
          {open?.map (i => {
            return (
            <p key={getPortfolioName(i)?.key} className="modal-name" style={{ fontWeight: '600' }}>
              {`Name: ${getPortfolioName(i)?.name} (code: ${getPortfolioName(i)?.code})`}
            </p>
            );
          })
          }
        </Col>
      </Row>
      <Row justify="end" style={{marginTop: '50px'}}>
      <Col>
        <Button
          className="modal-action-btn cancel-btn"
          onClick={close}
        >
          {t('CANCEL')}
        </Button>
        <Button className="modal-action-btn save-btn" onClick={onExport}>
          {t('EXPORT')}
        </Button>
      </Col>
      </Row>
    </Modal>
  );
};

export default ModalExportPortfolio;

ModalExportPortfolio.propTypes ={
  open: PropTypes.array,
  close: PropTypes.func,
  portfolios: PropTypes.array,
};